require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./es-articles-distruptingdigitalbanking.json") })
        }
      }, "path---es-articles-distruptingdigitalbanking");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---es-articles-distruptingdigitalbanking!./.cache/json/es-articles-distruptingdigitalbanking.json
// module id = 2089
// module chunks = 231608221292675